import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { LOGO } from '../constants';

@Injectable({
  providedIn: 'root'
})

export class ImageService {
  constructor(private http: HttpClient,
    @Inject('API_URL') private apiUrl: string
  ) { }

  getImage(id: number, type: number) {
    return this.http.get(`${this.apiUrl}image/get/${id}`, {
      params: new HttpParams().set('type', type),
      observe: 'response', 
      responseType: 'text' 
    });
  }

  getLogo() {
    this.http.get(`${this.apiUrl}image/logo`, { responseType: 'text' }).subscribe(res => {
      sessionStorage.setItem(LOGO, res);
    });
  }
}